export default __webpack_public_path__ + "static/media/crm.3210591b.svg";